/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t={waapi:()=>Object.hasOwnProperty.call(Element.prototype,"animate")},o={},e={};for(const a in t)e[a]=()=>(void 0===o[a]&&(o[a]=t[a]()),o[a]);export{e as supports};
//# sourceMappingURL=supports.js.map
